import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const CUSTOMER_VISIBILITY_HELP =
  'Controls whether this line item is shown to the customer. When "Visible to customer" is on, the line appears on the customer-facing quote as its own row. When off, the row becomes a child and its amount is rolled up into the selected parent, so the customer sees only the parent total without the internal breakdown.';

export const CustomerVisibilityHeader = () => (
  <Stack direction="row" gap="0.25rem" alignItems="center">
    <Tooltip title={CUSTOMER_VISIBILITY_HELP} placement="top" arrow>
      <InfoOutlined fontSize="small" color="info" sx={{ cursor: 'help' }} />
    </Tooltip>

    <Typography variant="subtitle2" component="span">
      Customer visibility
    </Typography>
  </Stack>
);
